import ContactBreadcrumb from "./ContactBreadcrumb";
import ContactUsSection from "./ContactUsSection";
import ContactFormSection from "./ContactFormSection";
import MapSection from "./MapSection";


export default function Contact() {
  return (
    <div>
      <ContactBreadcrumb />
      <ContactUsSection  />
        <ContactFormSection />  
        <MapSection />
        
    </div>
  );
}